import { Container } from "@mui/material";
import React from "react";
import Header from "../components/common/Header";
import IntroCard from "../components/Cards/IntroCard";
import LoginFormPay from "../components/Forms/LoginFromPay";
import "../Style/Theme/index.css";
import ContainerWithLogo from "./ContainerWithLogo";

export default function LoginPay() {
  return (
    <>
      <ContainerWithLogo>
        <LoginFormPay />
      </ContainerWithLogo>
    </>
  );
}
